/** Top-level layout roots and auth-only paths shared between router and guards. */
export const ROUTE_PATHS = Object.freeze({
  login: '/login',
  forgotPassword: '/forgotpassword',
  maintenance: '/maintenance',
  pdfViewer: '/pdf',
  account: '/',
  notifications: '/notifications',
  profile: '/profile',
  group: '/ryhma',
  admin: '/admin',
})
